import iSelfEmployedPageBg from "../../assets/icons/self-employed-form-page/self-employed-form-bg.svg";
import PageTitle from "../../components/common/page-title/page-title";
import SelfEmployedFormPageAccordionList from "../../components/self-employed-page/self-employed-page-accordion-list/self-employed-page-accordion-list";
import SelfEmployedFormPageInfo from "../../components/self-employed-page/self-employed-page-info/self-employed-page-info";
import SelfEmployedFormPageForm from "../../components/self-employed-page/self-employed-page-form/self-employed-page-form";
import SelfEmployedFormPageRegistrationData from "../../components/self-employed-page/self-employed-page-registration-data/self-employed-page-registration-data";
import "./self-employed-form-page.sass";

const SelfEmployedFormPage = () => {
  return (
    <div className="page self-employed-form-page">
      <div className="self-employed-form-page__block">
        <PageTitle>
          Регистрация
          <br />
          самозанятого CREON
        </PageTitle>

        <SelfEmployedFormPageInfo />
      </div>

      <div className="self-employed-form-page__block">
        <SelfEmployedFormPageRegistrationData />
      </div>

      <div className="self-employed-form-page__block">
        <SelfEmployedFormPageAccordionList />
      </div>

      <div className="self-employed-form-page__block" id="form">
        <SelfEmployedFormPageForm />
      </div>
      <img
        src={iSelfEmployedPageBg}
        className="img-absolute self-employed-form-page__bg"
        alt=""
      />
    </div>
  );
};

export default SelfEmployedFormPage;
